import {TextStyle} from 'react-native';

export const typography = {
  // Time display - Extra large for visibility
  time: {
    fontSize: 72,
    fontWeight: '300',
    lineHeight: 80,
  } as TextStyle,

  // Greeting
  greeting: {
    fontSize: 36,
    fontWeight: '500',
    lineHeight: 44,
  } as TextStyle,

  // Headlines
  h1: {
    fontSize: 48,
    fontWeight: '700',
    lineHeight: 56,
  } as TextStyle,

  h2: {
    fontSize: 32,
    fontWeight: '600',
    lineHeight: 40,
  } as TextStyle,

  h3: {
    fontSize: 24,
    fontWeight: '600',
    lineHeight: 32,
  } as TextStyle,

  // Body text - Large for readability
  body: {
    fontSize: 24,
    fontWeight: '400',
    lineHeight: 32,
  } as TextStyle,

  bodySmall: {
    fontSize: 18,
    fontWeight: '400',
    lineHeight: 24,
  } as TextStyle,

  // Reminders
  reminder: {
    fontSize: 20,
    fontWeight: '400',
    lineHeight: 28,
  } as TextStyle,

  // Buttons
  button: {
    fontSize: 24,
    fontWeight: '600',
    lineHeight: 32,
  } as TextStyle,

  buttonSmall: {
    fontSize: 18,
    fontWeight: '600',
    lineHeight: 24,
  } as TextStyle,

  // Date display
  date: {
    fontSize: 28,
    fontWeight: '400',
    lineHeight: 36,
  } as TextStyle,
} as const;

export type TypographyName = keyof typeof typography;
